// @ts-nocheck

import { BetFilterActionTypes } from '../types/actions/betFilter';

export const betFilterInitialState = {
  id: null,
  isPending: false,
};

export default (state = betFilterInitialState, action) => {
  switch (action.type) {
    case BetFilterActionTypes.SET_BET_FILTER: {
      const { id } = action.payload;
      return {
        ...state,
        id,
      };
    }
    case BetFilterActionTypes.SET_BET_FILTER_PENDING: {
      const { isPending } = action.payload;
      return {
        ...state,
        isPending,
      };
    }
    case BetFilterActionTypes.RECEIVE_BET_FILTER: {
      const { id } = action.payload;
      if (id === state.id) {
        return {
          ...state,
          isPending: false,
        };
      }
      return state;
    }
    default:
      return state;
  }
};
